var map = {
	"./accountability-assistant.svg": 794,
	"./call-center.svg": 6243,
	"./default-icon.svg": 902,
	"./intelligence-dashboard.svg": 8919,
	"./property-management.svg": 8887,
	"./revenue-management.svg": 1317,
	"./s360-automation.svg": 6784,
	"./s360-operations.svg": 5769,
	"./s360-sales.svg": 394,
	"./unified-communications.svg": 1651,
	"./website-management.svg": 6750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9567;